import { ELEMENTS } from "../../utils";
import options from "./shop-option";

const shopOrOnlineElements = [
  {
    id: ELEMENTS.PURCHASED_FROM,
    type: "radio",
    options: [
      { value: "online", label: "Online (John Lewis website, app or over the phone)" },
      { value: "shop", label: "In a John Lewis shop" },
    ],
    title: "Where did you buy the item?",
  },
  {
    id: ELEMENTS.PURCHASED_SHOP,
    type: "select",
    title: "Which John Lewis shop?",
    description: "",
    options: [...options],
  },
  {
    id: ELEMENTS.PURCHASED_PAYMENT_MODE,
    type: "radio",
    title: "How did you pay?",
    description:
      "Please check your receipt as you can only continue with store refunds paid for with credit/debit cards using this form. We’ll refund all other payment types in a shop.",
    options: [
      {
        value: "credit-or-debit-card",
        label: "Credit/debit card only",
      },
      {
        value: "cash-or-vouchers-or-gift",
        label: "Cash, vouchers or a gift card",
        supportingLabel: "Or more than one payment type, such as cash or a credit card.",
      },
    ],
  },
  {
    id: ELEMENTS.ERROR_MESSAGE_PAYMENT_MODE,
    type: "message",
    componentProps: {
      type: "error",
      title: "We can only offer credit/debit card refunds online",
      body: "You can visit us in a John Lewis shop to request your refund.",
      role: "alert",
      wideTab: true,
      buttonProps: {
        href: "/our-shops",
        rel: "noopener noreferrer",
        tag: "a",
      },
      whiteBackground: true,
      buttonText: "Find your nearest John Lewis shop.",
    },
  },
];

export default shopOrOnlineElements;
